// The usage events of cms-ui, tenant-ui and user-ui (spec frontend-usage-tracking, openspec
// frontend-usage-analytics design D7). A property is a value from a fixed set, a number or a boolean:
// `CatalogCheck` below fails to compile when one is a plain `string`, so free text cannot be recorded.
export const CONTENT_TYPES = [
    "article", "story", "image", "quiz", "video", "audio", "oembed", "poll", "form", "href", "plainHtml",
    "plainText", "mozillaReadability", "openGraph", "brand", "container", "transcript", "agent", "feed",
];
// The tools the CMS MCP server offers; a tool added later is recorded as `other` until it is listed here.
export const MCP_TOOLS = [
    "add_url_source", "archive_artifact", "copy_source_as_article", "create_empty_artifact", "describe_content_type",
    "edit_artifact", "edit_artifact_elements", "extract_artifact_text", "get_artifact",
    "get_content_generation_instructions", "get_data_source_item", "get_story_templates", "import_data_source_item",
    "latest_from_data_source", "list_data_sources", "list_organizations", "publish_artifact",
    "restore_artifact_version", "search_artifacts", "search_data_source", "search_data_source_entities",
    "set_artifact_tags", "top_from_data_source", "unpublish_artifact",
];
export const CONNECTORS = ["rss", "vnp", "kicker"];
export const STORY_TEMPLATES = [
    "title-cover", "photo-headline", "quote", "fact-list", "poll-sticker", "quiz-full", "form-full", "cta-end", "blank",
];
// Compile-time guard: a `string`-typed property turns into `never` here, and the assignment fails.
export const catalogCheck = null;
/** `value` when it is one of `known`, otherwise `"other"`: for values the server supplies, which may grow. */
export function knownOr(value, known) {
    return value !== undefined && value !== null && known.includes(value) ? value : "other";
}
export const contentTypeOf = (value) => knownOr(value, CONTENT_TYPES);
//# sourceMappingURL=catalog.js.map